<template>
	<div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
		<div class="form-group mb-2">
			<label class="d-block font-weight-bold">
				{{ label }}
				<span v-if="required" class="text-danger">*</span>
			</label>
			<div class="input-group mb-3">
				<div class="custom-file">
					<input
						v-bind:value="item"
						v-on:input="$emit('input', item)"
						type="file"
						class="custom-file-input"
						:readonly="readonly"
						:placeholder="placeholder"
						ref="file"
					/>
					<label class="custom-file-label">{{ item ? item : textInput }}</label>
				</div>
				<div class="input-group-append">
					<button
						class="btn"
						:class="btnClass ? btnClass : 'btn-outline-secondary'"
						type="button"
						@click="sendFile"
					>
						{{ btnText }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: [
		"value",
		"label",
		"textInput",
		"required",
		"grid",
		"readonly",
		"btnText",
		"placeholder",
		"btnClass",
	],
	data() {
		return { item: null };
	},
	beforeMount() {
		this.item = this.value;
	},
	watch: {
		value(n, o) {
			this.item = n;
		},
	},
	methods: {
		async sendFile() {
			this.item = this.$refs.file.files[0].name;
			this.$emit("submit", [this.$refs.file.files[0]]);
			this.$refs.file.value = null;
		},
	},
};
</script>
